<template>
  <el-container direction="vertical">
    <!-- 选项区域 -->
    <el-header class="options-header">
      <el-radio-group v-model="selectedOption" @change="changeAgency">
        <el-radio-button v-for="option in p_options" :key="option.value" :label="option">
          {{ option }}
        </el-radio-button>
      </el-radio-group>
    </el-header>

    <!-- 图表区域 -->
    <el-main class="chart-main">
      <StockAnalysisChart :stockData="stockData" :agency="selectedOption" />
    </el-main>

    <!-- 分页区域 -->
    <el-footer class="pagination-footer">
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1" class="pagination-button">上一页</button>
        <span class="page-info">{{ currentPage }} / {{ totalPages }}</span>
        <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-button">下一页</button>
      </div>
    </el-footer>
  </el-container>
</template>


<script>
import axios from 'axios';
import StockAnalysisChart from '@/components/StockAnalysisChart.vue'; // 修改路径
export default {
     components: {
       StockAnalysisChart
     },
     data() {
        return {
            data: {},
              stockData: {
                sellData: [],
                buyData: [],
                holdData: []
             },
            selectedOption:'炒股养家',
            itemsPerPage: 10,
            currentPage: 1,
            totalRecords: 0,
            perPage: 4,
            p_options: [],
            currentChartData: [], // 当前显示的图表数据
            chartType: 'sell', // 当前显示的数据类型，默认为卖出数据
        };
    },
    computed: {
        totalPages() {
          return Math.ceil(this.totalRecords / this.perPage);
        },

        filteredTableData() {
          if (!this.selectedStructure) {
            return this.tableData;
          }

      const startIndex = this.tableData.findIndex(item => item.structure === this.selectedStructure);
      if (startIndex === -1) {
        return [];
      }
      return this.tableData.slice(startIndex, startIndex + 5);
    }
  },
    methods: {
     async agency_all() {
      try {
        const response = await axios.get(`/api/agency_all`);
        this.p_options = response.data;
        console.info(this.p_options);
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    changeAgency() {

        this.currentPage=1;
        this.fetchDataChart();
    },
    async fetchDataChart() {
            console.log('开始请求数据:', this.questionQuery);
            const currentPage = this.currentPage;
            const limit = this.perPage;
            console.log('当前页码:', this.currentPage);
            try {
                const responses = await axios.get(`/api/toplevel`, { params: { agency: this.selectedOption, limit: limit, offset: currentPage } });
                const responseData = responses.data;
                if (responseData == "暂无数据") return;
                this.stockData = responseData.data;
                console.info(responseData);
                this.totalRecords = responseData.total_count;
                console.log('所有请求完成:', this.stockData); // 添加调试信息
            } catch (error) {
                console.error('请求失败:', error);
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchDataChart();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchDataChart();
            }
        },
    },
    mounted() {
        this.agency_all();
        this.fetchDataChart();
    },
};
</script>
<style scoped>
.options-header {
  margin-bottom: 20px;
}

.el-radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-radio-button__inner {
  padding: 8px 16px;
}

.chart-main {
  flex: 1;
  padding: 0;
}

.pagination-footer {
  text-align: center;
  margin-top: 20px;
}

.pagination-button {
  padding: 8px 16px;
  margin: 0 5px;
  cursor: pointer;
  border: none;
  border-radius: 4px;
  background-color: #409EFF; /* Element UI 主色调 */
  color: white;
  transition: background-color 0.3s ease;
}

.pagination-button:hover:not(:disabled) {
  background-color: #66b1ff;
}

.pagination-button:disabled {
  background-color: #ebeef5;
  color: #c0c4cc;
  cursor: not-allowed;
}


</style>